<template>
  <v-menu offset-y top :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch edit</v-btn>
    </template>
    <v-card flat width="700">
      <v-card-title>Batch edit</v-card-title>
      <v-card-subtitle>Only checked fields will be updated</v-card-subtitle>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row>
            <v-col cols="1">
              <v-checkbox v-model="input.updateActive"/>
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Active" v-model="input.active" hide-detlails :disabled="!input.updateActive"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1">
              <v-checkbox v-model="input.updateLowBondedInventoryCases" class="mt-0"/>
            </v-col>
            <v-col cols="3">
              <decimal-number-input label="Building point" v-model="input.lowBondedInventoryCases" prefix="" suffix="cases" :precision="0" integer no-minimum :disabled="!input.updateLowBondedInventoryCases"/>
            </v-col>
            <v-col cols="1" offset="2">
              <v-checkbox v-model="input.updateLowDutyPaidInventoryBottles" class="mt-0"/>
            </v-col>
            <v-col cols="3">
              <decimal-number-input label="Duty-paid low inv." v-model="input.lowDutyPaidInventoryBottles" prefix="" suffix="bottles" :precision="0" integer no-minimum :disabled="!input.updateLowDutyPaidInventoryBottles"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1">
              <v-simple-checkbox v-model="input.updateCategory" class="mt-2"/>
            </v-col>
            <v-col cols="5">
              <inventory-categories-select v-model="input.categoryId" label="Category" type="Product" allow-add hide-detalils :disabled="!input.updateCategory"/>
            </v-col>
          </v-row>

          <template v-if="connectedToAccounting && values">
            <v-row>
              <v-col cols="1">
                <v-checkbox class="mt-2" v-model="input.updateBondedInventoryAccount"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.bondedInventoryAccountRef" label="In-bond inventory asset account"
                                :disabled="!input.updateBondedInventoryAccount"
                                :accounts="inventoryAccounts" :addTypes="['OtherCurrentAsset']" hint=""/>
              </v-col>
              <v-col cols="1">
                <v-checkbox class="mt-2" v-model="input.updateDutyPaidInventoryAccount"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.dutyPaidInventoryAccountRef" label="Duty-paid inventory asset account"
                                :disabled="!input.updateDutyPaidInventoryAccount"
                                :accounts="inventoryAccounts" :addTypes="['OtherCurrentAsset']" hint=""/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1">
                <v-checkbox class="mt-2" v-model="input.updateBondedIncomeAccount"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.bondedIncomeAccountRef" label="In-bond income account"
                                :disabled="!input.updateBondedIncomeAccount"
                                :accounts="incomeAccounts" :addTypes="['Income']" hint=""/>
              </v-col>
              <v-col cols="1">
                <v-checkbox class="mt-2" v-model="input.updateDutyPaidIncomeAccount"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.dutyPaidIncomeAccountRef" label="Duty-paid income account"
                                :disabled="!input.updateDutyPaidIncomeAccount"
                                :accounts="incomeAccounts" :addTypes="['Income']" hint=""/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1">
                <v-checkbox class="mt-2" v-model="input.updateBondedCogAccount"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.bondedCogAccountRef" label="In-bond cost of goods account"
                                :disabled="!input.updateBondedCogAccount"
                                :accounts="cogAccounts" :addTypes="['CostOfGoodsSold']" hint=""/>
              </v-col>
              <v-col cols="1">
                <v-checkbox class="mt-2" v-model="input.updateDutyPaidCogAccount"/>
              </v-col>
              <v-col>
                <account-picker v-model="input.dutyPaidCogAccountRef" label="Duty-paid cost of goods account"
                                :disabled="!input.updateDutyPaidCogAccount"
                                :accounts="cogAccounts" :addTypes="['CostOfGoodsSold']" hint=""/>
              </v-col>
            </v-row>
          </template>

        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'

export default {
  name: 'InventoryProductsBatchEdit',
  components: {InventoryCategoriesSelect},
  props: {
    products: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {updateActive: false, updateCategory: false,
              updateLowBondedInventoryCases: false, updateLowDutyPaidInventoryBottles: false,
              updateBondedInventoryAccount: false, updateDutyPaidInventoryAccount: false,
              updateBondedIncomeAccount: false, updateDutyPaidIncomeAccount: false,
              updateBondedCogAccount: false, updateDutyPaidCogAccount: false,
              active:true, categoryId:'',
              lowBondedInventoryCases: -1, lowDutyPaidInventoryBottles: -1,
              bondedInventoryAccountRef: '', dutyPaidInventoryAccountRef: '',
              bondedIncomeAccountRef: '', dutyPaidIncomeAccountRef: '',
              bondedCogAccountRef: '', dutyPaidCogAccountRef: '',
              products:[]},
      accounts: [],
      saving: false
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    inventoryAccounts() {
      return this.accounts.filter(account => account.type === 'OtherCurrentAsset');
    },
    incomeAccounts() {
      return this.accounts.filter(account => account.type === 'Income');
    },
    cogAccounts() {
      return this.accounts.filter(account => account.type === 'CostOfGoodsSold');
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  async created() {
    if (!this.connectedToAccounting)
      return;

    const results = await this.$apiCall(`query InventoryProductsBatchEdit($currency: String!) {
                                            companyAccounts {
                                              bondedProductInventory,bondedProductCOG,bondedProductIncome,
                                              dutyPaidProductInventory,dutyPaidProductCOG,dutyPaidProductIncome
                                            }
                                            accounts(currency:$currency) {
                                              ref,name,type
                                            }
                                          }`,
                                        {currency:this.$store.getters.company.settings.homeCurrency});
    if (!results.error) {
      this.accounts = results.data.accounts;
      this.input.bondedInventoryAccountRef = results.data.companyAccounts.bondedProductInventory;
      this.input.dutyPaidInventoryAccountRef = results.data.companyAccounts.dutyPaidProductInventory;
      this.input.bondedIncomeAccountRef = results.data.companyAccounts.bondedProductIncome;
      this.input.dutyPaidIncomeAccountRef = results.data.companyAccounts.dutyPaidProductIncome;
      this.input.bondedCogAccountRef = results.data.companyAccounts.bondedProductCOG;
      this.input.dutyPaidCogAccountRef = results.data.companyAccounts.dutyPaidProductCOG;
    }
  },
  methods: {
    async save() {
      this.saving = true;
      this.input.products = this.products.map(product => product.id);
      const results = await this.$apiCall(`mutation InventoryProductsBatchEdit($input: ProductBatchUpdateInput!) {
                                              productsBatchUpdate(input:$input) {id,error}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.productsBatchUpdate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Updated ${this.products.length - errorCount} of ${this.products.length} products\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.productsBatchUpdate);
      }
    }
  }
}
</script>